// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-schemas
import * as z from 'zod'

// This is the base schema that can be extended when using it in configs
export const BaseSchema_ContentsV1LukoToGetsafeDe = z.object({
  town: z.string().optional(),
  street: z.string().optional(),
  house_no: z.string().optional(),
  zip_code: z.string().min(1).optional(),
  ownership: z.enum(['owner', 'renter']).optional(),
  bike_price: z
    .preprocess((val) => {
      if (val === '' || val === undefined) {
        return undefined
      }
      return Number(val)
    }, z.number().int().gte(0).lte(5000))
    .optional(),
  tariff_line: z.enum(['basic', 'plus', 'premium']),
  type_of_home: z.enum(['apartment', 'house']).optional(),
  bike_coverage: z.boolean(),
  glass_coverage: z.boolean(),
  insured_sum_amount: z
    .preprocess((val) => {
      if (val === '' || val === undefined) {
        return undefined
      }
      return Number(val)
    }, z.number().int().gte(5000).lte(250_000))
    .optional(),
  gross_negligence_coverage: z.boolean(),
  living_space_square_meters: z
    .preprocess((val) => {
      if (val === '' || val === undefined) {
        return undefined
      }
      return Number(val)
    }, z.number().int().gte(10).lte(300))
    .optional(),
  number_of_claims_in_last_3y: z.enum(['0-2', '3+']).optional(),
  cancelled_by_previous_insurer: z.boolean().optional(),
})

const Schema_ContentsV1LukoToGetsafeDe = BaseSchema_ContentsV1LukoToGetsafeDe.superRefine(
  (values, ctx) => {
    if (values['bike_coverage'] !== undefined && [true].includes(values['bike_coverage'])) {
      if (values['bike_price'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'integer',
          received: 'undefined',
          message: 'Required',
          path: ['bike_price'],
        })
      }
    }
  }
)

export default Schema_ContentsV1LukoToGetsafeDe
